import './App.css';
import space_drift from './assets/space_drift.mp4'
import lavalamp from './assets/lavalamp_red.mp4'
import sunlight from './assets/sunlight.mp4'
import soundtracker from './assets/soundtracker.mp4'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h2>Sunshine Development</h2>
        <p>by Kai Sunshine Frazier</p>
      </header>
      <main>
        <div className="display">
          <video src={soundtracker} className="video" loop="true" controls/>
          <div className="description" >
            <h3>Soundtracker Demo</h3>
            A demo for the Soundtracker app, which uses AI to play music based on an image or text prompt.
            Made using React Native, Expo, Gemini 1.5, Azure, and Spotify for Developers.
          </div>
        </div>
        <div className="display">
          <div className="description" >
            <h3>Lavalamp</h3>
            This graphic runs in React Native. It uses animation values from Reanimated and path interpolation from Skia.
            The techniques in use are derived value functions, Perlin noise, a metaball effect, and RGB gradient functions.
          </div>
          <video src={lavalamp} className="video" loop="true" autoplay="autoplay" muted/>
        </div>
        <div className="display">
          <video src={space_drift} className="video" loop="true" autoplay="autoplay" muted/>
          <div className="description" >
            <h3>Space Drift</h3>
            This fragment shader is run on the GPU, coded in GLSL and displayed using GlslViewer.
            The primary techniques in use are cellular noise and RGB gradient functions.
          </div>
        </div>
        <div className="display">
          <div className="description" >
            <h3>Sunlight</h3>
            This fragment shader is run on the GPU, coded in GLSL and displayed using GlslViewer.
            The techniques in use are 3D looping noise and parallax motion.
          </div>
          <video src={sunlight} className="video" loop="true" autoplay="autoplay" muted/>
        </div>
      </main>
    </div>
  );
}

export default App;
